import React, { useState, useEffect } from 'react'
import {
  Container,
  Grow,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
  FormControl,
  TextField,
  Select,
  MenuItem,
  InputLabel
} from '@material-ui/core'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

import Button from '@material-ui/core/Button'
import RemoveCircleOutlineOutlined from '@material-ui/icons/RemoveCircleOutlineOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'

import { Link, useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import useStyles from './styles'
import {
  URL,
  API_URL,
  AddColorCode,
  Edit,
  Results,
  Category,
  Type,
  VehicleName,
  ColorCode,
  CreatedDate,
  SelectCategory,
  AreYouSureToDelete,
  FilterByCategory,
  DeleteSuccess,
  GoBack,
  Close,
  ListColorCode
} from '../../constants/actionTypes'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

const Dashboard = () => {
  const [open, setOpen] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
  }
  const API = axios.create({
    baseURL: API_URL
  })
  const classes = useStyles()

  const [dataColors, setDataColors] = useState([])
  const [listCategory, setListCategory] = useState([])

  const [postData, setPostData] = useState({
    Category: '',
    VehicleNameInput: ''
  })

  let data = useLocation()
  const navigate = useNavigate()
  const loginSuccess = JSON.parse(localStorage.getItem('colorMixingHipic'))
  if (!loginSuccess) {
    navigate(URL + '/login')
  }

  const updateJson = (jsonData) =>
    API.post('/newhipic/ColorMixing/deleteColorMixing', jsonData)

  const handleDelete = async (id) => {
    console.log(dataColors)
    const dataDelete = dataColors.filter((item) => item.id !== id)

    setSortDataColors(dataDelete)
    updateJson(dataDelete)
    setOpen(true)
    navigate(URL + '/dashboard')
    navigate(0)
  }

  const [sortDataColors, setSortDataColors] = useState([])

  const sortTableExpASC = () => {
    let sortDataColors = [...dataColors]
    sortDataColors.sort((a, b) => {
      if (a.createDate < b.createDate) {
        return -1
      }
      if (a.createDate > b.createDate) {
        return 1
      }
      return 0
    })
    setSortDataColors(sortDataColors)
  }
  const sortTableExpDESC = () => {
    let sortDataColors = [...dataColors]
    sortDataColors.sort((a, b) => {
      if (a.createDate < b.createDate) {
        return 1
      }
      if (a.createDate > b.createDate) {
        return -1
      }
      return 0
    })

    setSortDataColors(sortDataColors)
  }
  //delete certificate

  //get all Post
  const sortByDate = (a, b) => {
    let dateA1 = new Date(a.createDate)
    let dateA2 = new Date(b.createDate)

    return dateA1 - dateA2
  }
  const [vehicleNameInput, setVehicleNameInput] = useState('')
  const filterBySearch = (e) => {
    // Access input value
    const nameInput = e.target.value

    setVehicleNameInput(nameInput)
    const query = e.target.value
    // Create copy of item list
    var updatedList = [...dataColors]
    // Include all elements which includes the search query
    updatedList = updatedList.filter(
      (item) => item.nameCode.toLowerCase().indexOf(query.toLowerCase()) !== -1
    )

    // Trigger render with updated values
    //setDataColors(updatedList)
    setSortDataColors(updatedList)
  }

  const getAllColors = async () => {
    let arrayData = []
    let dataColorMixingPath = ''
    let arrayCategory = []
    // if (location.state.rePrint) {
    dataColorMixingPath = `${API_URL}/uploadshipic/src3/dataColorMixingHipic.json`
    axios
      .get(dataColorMixingPath, {
        crossdomain: true
      })
      .then((res) => {
        const dataColorMixing = res.data

        dataColorMixing.map((items) => {
          arrayCategory.push(items.category)
        })
        dataColorMixing.map((items) => {
          arrayData.push({
            id: items.id,
            type: items.type,
            category: items.category,
            colorCode: items.colorCode,
            nameCode: items.nameCode,
            vehicleName: items.vehicleName,
            content: items.content,
            info: items.info,
            version: items.version,
            files: items.files,
            filesStatus: items.filesStatus,
            fileSize: items.fileSize,
            volume: items.volume,
            createDate: items.createDate
          })
        })

        arrayData.sort(sortByDate)

        setDataColors(arrayData)
        setSortDataColors(arrayData)
      })
      .catch((error) => {
        console.log(error)
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      })
  }

  const getAllColorsSort = async (postData) => {
    let arrayData = []
    const { Category } = postData
    let arrayCategory = []
    let dataColorMixingPath = ''
    // if (location.state.rePrint) {
    dataColorMixingPath = `${API_URL}/uploadshipic/src3/dataColorMixingHipic.json`
    axios
      .get(dataColorMixingPath, {
        crossdomain: true
      })
      .then((res) => {
        const dataColorMixing = res.data

        dataColorMixing.map((items) => {
          arrayCategory.push(items.category)
        })
        dataColorMixing.map((items) => {
          if (Category && Category !== '') {
            if (items.category === Category) {
              arrayData.push({
                id: items.id,
                type: items.type,
                category: items.category,
                colorCode: items.colorCode,
                nameCode: items.nameCode,
                vehicleName: items.vehicleName,
                content: items.content,
                info: items.info,
                version: items.version,

                files: items.files,
                filesStatus: items.filesStatus,
                fileSize: items.fileSize,
                volume: items.volume,
                createDate: items.createDate
              })
            }
          } else {
            arrayData.push({
              id: items.id,
              type: items.type,
              category: items.category,
              colorCode: items.colorCode,
              nameCode: items.nameCode,
              vehicleName: items.vehicleName,
              content: items.content,
              info: items.info,
              version: items.version,
              files: items.files,
              filesStatus: items.filesStatus,
              fileSize: items.fileSize,
              volume: items.volume,
              createDate: items.createDate
            })
          }
        })

        const namesArr = arrayCategory.filter(function (elem, pos) {
          return arrayCategory.indexOf(elem) == pos
        })

        arrayData.sort(sortByDate)
        setListCategory(namesArr)
        setSortDataColors(arrayData)
      })
      .catch((error) => {
        console.log(error)
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      })
  }

  useEffect(() => {
    getAllColors()
    // if (!loginSuccess) {
    //   navigate(URL + '/login')
    // } else {
    if (vehicleNameInput == '' || !vehicleNameInput) {
      getAllColorsSort(postData)
      // }
    }
  }, [postData])
  return (
    <Grow in>
      <Container className='pageInstructors'>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
          className='wrapper'
        >
          <Grid item xs={12} sm={12}>
            <div className='moreButton' style={{ marginTop: '10px' }}>
              <Link
                to={{
                  pathname: URL + '/',
                  state: { fromDashboard: true }
                }}
              >
                <Button
                  style={{ marginRight: '10px' }}
                  className={classes.buttonLink}
                  type='button'
                >
                  {GoBack}
                </Button>
              </Link>
              <Link
                to={{
                  pathname: URL + '/dashboard/add-color',
                  state: { fromDashboard: true }
                }}
              >
                <Button className={classes.buttonLink} type='button'>
                  {AddColorCode}
                </Button>
              </Link>
              <Link
                to={{
                  pathname: URL + '/dashboard/list-color',
                  state: { fromDashboard: true }
                }}
              >
                <Button className={classes.listColorCode} type='button'>
                  {ListColorCode}
                </Button>
              </Link>
            </div>
            <div className={classes.selectLocation}>
              <div className='wrapSelect'>
                <FormControl fullWidth className={classes.formControl}>
                  <InputLabel id='demo-simple-select-label'>
                    {FilterByCategory} *
                  </InputLabel>

                  <Select
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={postData.Category}
                    label={Category}
                    required
                    // error={postData.Location == '' ? 'error' : null}
                    onChange={(e) =>
                      setPostData({
                        ...postData,
                        Category: e.target.value
                      })
                    }
                  >
                    <MenuItem key={'lo'} value=''>
                      {SelectCategory}
                    </MenuItem>
                    {listCategory.map((item, index) => (
                      <MenuItem key={item + index + 'lo'} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className='wrapInput'>
                <FormControl
                  fullWidth
                  className={classes.formControl}
                  style={{ position: 'relative' }}
                >
                  <TextField
                    className={classes.fileInput}
                    name='studentName'
                    variant='outlined'
                    label='Tên Màu'
                    fullWidth
                    value={vehicleNameInput}
                    onChange={filterBySearch}
                  />
                </FormControl>
              </div>
            </div>
            <div className='wrapListResult'>
              <List
                className='listResult'
                sx={{
                  width: '100%',
                  maxWidth: 360,
                  bgcolor: 'background.paper'
                }}
              >
                {sortDataColors.length == 0 ? (
                  <ListItem key='notFound' disableGutters>
                    <ListItemText primary={`Not Found!!!`} />
                  </ListItem>
                ) : (
                  ''
                )}

                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 'min-content' }}
                    aria-label='simple table'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align='center'>STT</TableCell>
                        <TableCell align='center'>{Type}</TableCell>
                        <TableCell align='center'>{Category}</TableCell>
                        <TableCell align='center'>Tên Màu</TableCell>
                        <TableCell align='center'>{ColorCode}</TableCell>
                        <TableCell align='center'>{CreatedDate}</TableCell>
                        <TableCell align='center'>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      style={{
                        minHeight: '100px',
                        background: '#fff',
                        width: '100%',
                        display: 'inline-masonry'
                      }}
                    >
                      {sortDataColors?.map((row, index) => (
                        <TableRow
                          key={row.type + index}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell
                            align='center'
                            component='th'
                            scope='row'
                            style={{ padding: '8px' }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            align='center'
                            scope='row'
                            style={{ padding: '8px' }}
                          >
                            {row.type}
                          </TableCell>
                          <TableCell align='center' style={{ padding: '8px' }}>
                            {row.category}
                          </TableCell>
                          <TableCell align='center' style={{ padding: '8px' }}>
                            {row.nameCode}
                          </TableCell>
                          <TableCell align='center' style={{ padding: '8px' }}>
                            {row.colorCode}
                          </TableCell>
                          <TableCell align='center' style={{ padding: '8px' }}>
                            {row.createDate}
                          </TableCell>
                          <TableCell align='center' style={{ padding: '8px' }}>
                            {/* {' '}
                            {loginSuccess !== null || loginSuccess ? ( */}
                            <>
                              <Button
                                onClick={() => {
                                  handleDelete(row.id)
                                  // if (window.confirm(`${AreYouSureToDelete}`)) {
                                  //   handleDelete(row.vehicleName)
                                  // }
                                }}
                              >
                                <RemoveCircleOutlineOutlined
                                  style={{ color: 'red' }}
                                />
                              </Button>

                              <Link
                                to={{
                                  pathname: URL + '/dashboard/edit-color',
                                  search: `?id=${row.id}`,
                                  hash: '',
                                  state: { fromDashboard: true }
                                }}
                              >
                                <EditOutlinedIcon />
                              </Link>
                            </>
                            {/* ) : null} */}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* {sortDataColors?.map((value, index) => {
                  return (
                    <ListItem
                      style={{ paddingLeft: '16px', paddingRight: '16px' }}
                      key={value.vehicleName + index}
                      disableGutters
                    >
                      <ListItemText
                        className='InstructorName'
                        primary={`${value.type}`}
                        style={{ flexGrow: 2, width: '100px' }}
                      />
                      <ListItemText
                        className='InstructorEmail'
                        primary={`${value.category}`}
                      />
                      <ListItemText
                        className='NameVehicle'
                        primary={`${value.vehicleName}`}
                      />
                      <ListItemText
                        className='ColorCode'
                        primary={`${value.colorCode}`}
                      />
                      <ListItemText
                        className='CreateDate'
                        primary={`${value.createDate}`}
                      />

                      {loginSuccess !== null || loginSuccess ? (
                        <>
                          <Button
                            onClick={() => {
                              if (window.confirm(`${AreYouSureToDelete}`)) {
                                handleDelete(value.vehicleName)
                              }
                            }}
                          >
                            <RemoveCircleOutlineOutlined />
                          </Button>

                          <Link
                            to={{
                              pathname: URL + '/dashboard/edit-color',
                              search: `?id=${value.id}`,
                              hash: '',
                              state: { fromDashboard: true }
                            }}
                          >
                            {Edit}
                          </Link>
                        </>
                      ) : null}
                    </ListItem>
                  )
                })} */}
              </List>
            </div>
          </Grid>
        </Grid>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {DeleteSuccess}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>{Close}</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Grow>
  )
}

export default Dashboard
